<template>
    <v-dialog
        v-model="downloadDialog"
        width="500"
        :fullscreen="this.$vuetify.breakpoint.xsOnly"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-icon
                class="material-icons-outlined mr-7"
                :disabled="downloadDisabled"
                v-bind="attrs"
                @click="download"
            >
                file_download
            </v-icon>
        </template>
        <v-card id="ticket-download-dialog">
            <v-card-title class="text-h5 lighten-2">
                <v-icon 
                    color="primary"
                    class="material-icons-outlined"
                >
                    file_download
                </v-icon>
                <span>Download ({{ selectedTickets.length }})</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div
                    v-if="downloading"
                    class="download-progress"
                >
                    <v-progress-circular
                        indeterminate
                        size="50"
                        color="primary"
                    />
                    <div class="download-progress-text">
                        Please wait while your download is being generated.
                    </div>
                </div>
                <div v-else>
                    <div class="control-title">
                        Select Format
                    </div>
                    <v-radio-group
                        v-model="downloadFormat"
                        column
                        dense
                    >
                        <v-radio
                            label="Text (*.txt)"
                            value="text"
                        />
                        <v-radio
                            label="HTML (*.html)"
                            value="html"
                        />
                        <v-radio
                            label="External Routing (*.csv)"
                            value="csv"
                        />
                        <v-radio
                            label="Shapefile-Points (Zip Archive)"
                            value="shapefile-point"
                        />
                        <v-radio
                            label="Shapefile-Polygons (Zip Archive)"
                            value="shapefile-poly"
                        />
                    </v-radio-group>
                </div>
            </v-card-text>
            <div :class="{'mobile-download-buttons': !this.$vuetify.breakpoint.smAndUp }">
                <v-divider />
                <v-card-actions>
                    <v-spacer v-if="this.$vuetify.breakpoint.smAndUp" />
                    <v-btn
                        style="text-transform: none !important"
                        outlined
                        light
                        @click="downloadDialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        color="primary"
                        @click="saveDownload"
                    >
                        Download
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    props: {
        selectedTickets: {
            type: Array,
            default: () => ([]),
        },
    },
    data: () => ({
        downloadDialog: false,
        downloadFormat: 'text',
        downloading: false,
    }),
    computed: {
        downloadDisabled(){
            return this.selectedTickets.length === 0;
        },
    },
    methods: {
        download() {
            this.downloadDialog = true;
        },
        async saveDownload() {
            this.downloading = true;
            try {
                const ticketList = this.selectedTickets.map(ticket => (ticket.tid));
                await webtmsBackend.downloadTickets(this.downloadFormat, ticketList.join(','));
                this.downloadDialog = false;
            } catch (error) {
                console.error('download error ', error);
            }
            this.downloading = false;
        },
        closeDialog() {
            this.downloadDialog = false;
        }
    }, 
};
</script>
<style>
#ticket-download-dialog .v-card__title .v-icon {
    background-color: #F0F6FF;
    margin-right: 12px;
    border-radius: 50%;
    width: 32px;
    height: 32px;    
}
#ticket-download-dialog .control-title {
    margin-top: 16px;
    font-weight: 500;
    font-size: 16px;
    color: var(--ll-text-brand);
}
#ticket-download-dialog .v-card__title span {
    font-size: 20px;
}
#ticket-download-dialog .v-radio label {
    color: var(--ll-text-brand);
}
.mobile-download-buttons {
    position: fixed;
    bottom: 0px;
    width: 100%;
    text-align: center;
}
#ticket-download-dialog .mobile-download-buttons .v-card__actions {
    justify-content: center;
}
#ticket-download-dialog .mobile-download-buttons button {
    width: 162px;
}
#ticket-download-dialog .download-progress {
    text-align: center;
    padding-top: 40px;
}
#ticket-download-dialog .download-progress-text  {
    margin-top: 28px;
    margin-bottom: 24px;
    color: var(--ll-text-brand);
}
</style>
